@if(showOpenTable) {
<div class="relative w-full">
    <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center absolute top-1 right-1 text-xs cursor-pointer p-1 border rounded-base bg-white shadow-md z-10"
        (click)="openModel()"></i>
</div>
}


<app-dialog [visible]="OpenTableDialog" [showCloseButton]="true" [fullscreenOnMobile]="true"
    class="max-w-[80%]" (closed)="OpenTableDialog = false">
    <ng-template #bodyTemplate>
        <div class="p-4 prose prose-compact text-justify text-xs prose-ul:pl-1 prose-ol:pl-2 overflow-x-auto"
            [innerHTML]="table">
        </div>
    </ng-template>
</app-dialog>